/**
 * Comparator table navigation
 */
export class ComparatorTable {
    constructor() {
        this.table = document.querySelector("[data-comparator-scroller]");
        if (!this.table) {
            return;
        }

        this.enablePrev = () => {
            this.prev.classList.remove("comparator-button-inactive");
        };

        this.disablePrev = () => {
            this.prev.classList.add("comparator-button-inactive");
        };

        this.enableNext = () => {
            this.next.classList.remove("comparator-button-inactive");
        };

        this.disableNext = () => {
            this.next.classList.add("comparator-button-inactive");
        };

        this.scroller = this.table.querySelector(".table-scroller");
        this.scroller.scrollLeft = 0;

        this.handleScollEnd = () => {
            this.offset = this.table.querySelector(
                "table tbody tr:first-of-type td:first-of-type"
            );
            this.offset = this.offset.getBoundingClientRect().width;
            if (
                Math.floor(
                    this.scroller.offsetWidth +
                        this.scroller.scrollLeft +
                        this.offset
                ) >= Math.floor(this.scroller.scrollWidth)
            ) {
                this.disableNext();
            }
        };

        this.handleScollStart = () => {
            if (Math.floor(this.scroller.scrollLeft) <= 10) {
                this.disablePrev();
            }
        };

        this.columns = this.table.querySelectorAll(
            "table tbody tr:first-of-type td:not(:first-of-type)"
        );

        this.column = 0;

        this.prev = this.table.querySelector("[data-prev]");
        if (this.prev) {
            this.prev.addEventListener("click", () => {
                if (this.column === 0) {
                    this.disablePrev();
                    return;
                }
                this.enablePrev();
                this.enableNext();
                this.column--;
                this.columns[this.column].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "start",
                });
                if (this.column === 0) {
                    this.disablePrev();
                }
                this.handleScollStart();
            });
        }

        this.next = this.table.querySelector("[data-next]");
        if (this.next) {
            this.next.addEventListener("click", () => {
                if (this.column === this.columns.length - 1) {
                    this.disableNext();
                    return;
                }
                this.enablePrev();
                this.enableNext();
                this.column++;
                this.columns[this.column].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "start",
                });
                if (this.column === this.columns.length - 1) {
                    this.disableNext();
                }
                this.handleScollEnd();
            });
        }

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.target.scrollWidth === entry.target.clientWidth) {
                    this.disablePrev();
                    this.disableNext();
                } else {
                    this.disablePrev();
                    this.enableNext();
                    entry.target.scrollLeft = 0;
                }
                return;
            }
        });

        resizeObserver.observe(this.scroller);
    }
}
